
import { Component, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider } from "vee-validate";
import {
  ISolCustomerCurrency,
  ISolCustomerDenomination,
  ISolCustomerDenominationQuantity,
  ISolCustomerPack,
  ISolCustomerPackQuantity,
} from "@/entities";
import Packs from "@/components/orders/Packs.vue";
import DenominationsComposition from "@/components/orders/DenominationsComposition.vue";
import { Getter } from "vuex-class";
import { Locale } from "@/store";
import HelpAdviseForm from "@/components/orders/HelpAdviseForm.vue";

@Component({
  name: "delivery-form",
  components: {
    Packs,
    DenominationsComposition,
    ValidationProvider,
    HelpAdviseForm,
  },
})
export default class DeliveryForm extends Vue {
  @Getter("getLocale") locale!: Locale;
  @Prop({ required: true })
  serviceDate!: Date;
  @Prop({ required: true, default: [] })
  packs!: ISolCustomerPack[];
  @Prop({ required: true })
  packQuantities!: ISolCustomerPackQuantity[];
  @Prop({ required: true, default: [] })
  currencies!: ISolCustomerCurrency[];
  @Prop({ required: true })
  currency!: ISolCustomerCurrency;
  @Prop({ required: true })
  denominations!: ISolCustomerDenomination[];
  @Prop({ required: true })
  denominationQuantities!: ISolCustomerDenominationQuantity[];
  @Prop({ required: true })
  comments!: string;
  @Prop({ required: true, default: false })
  isChange!: boolean;
  @Prop({ required: false, default: false })
  allowIntervalTime!: boolean;
  @Prop({ required: false })
  initialTime!: string;
  @Prop({ required: false })
  finalTime!: string;
  @Prop({ required: false, default: 2 })
  minimunIntervalTime!: number;
  @Prop({ required: false, default: 1 })
  minimunStartingInterval!: number;
  @Prop({ required: false, default: 8 })
  minimunHour!: number;
  @Prop({ required: false, default: 18 })
  maximunHour!: number;
  minDate: Date = new Date();

  constructor() {
    super();
  }

  mounted(): void {
    const now = new Date();
    this.minDate = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
  }

  get _serviceDate(): Date {
    return this.serviceDate;
  }
  set _serviceDate(value: Date) {
    this.$emit("update:serviceDate", value);
  }

  get _initialTime(): string {
    return this.initialTime;
  }
  set _initialTime(value: string) {
    this.$emit("update:initialTime", value);
  }

  get _finalTime(): string {
    return this.finalTime;
  }
  set _finalTime(value: string) {
    this.$emit("update:finalTime", value);
  }

  get _currency(): ISolCustomerCurrency {
    return this.currency;
  }
  set _currency(value: ISolCustomerCurrency) {
    this.$emit("update:currency", value);
  }
  get _comments(): string {
    return this.comments;
  }
  set _comments(value: string) {
    this.$emit("update:comments", value);
  }
}
